import React, { useEffect } from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';
import {
  isCommuneDPECheck,
  isCommuneDPECheckOptional,
  isCommuneDPEFile,
} from '../../constants/communes';
import env from '../../env/env.json';

const Validation = ({
  formData,
  setFormData,
  handleSignatureEnd,
  clearSignature,
  sigRef,
  handleChange,
  handleChangeFiles,
  handleResetFiles,
  tooltip,
  inputFocus,
  page,
  handleResetInputFiles,
  loading,
}) => {
  const annexe_3 = env.annexe_3;
  const CGU = env.CGU;

  //** Permet d'initialiser le tableau files */
  let files = {};

  useEffect(() => {
    if (!formData.files) {
      document.querySelectorAll('.files-upload').forEach((el) => {
        files[el.name] = [];
      });
      setFormData({ ...formData, files });
    }
  }, []);

  //** Permet de télécharger les pièces jointes lorsque les conditions de téléchargement sont validées */
  document.querySelectorAll('.files-upload').forEach((input) => {
    if (
      formData.Check13 !==
      "J'accepte les conditions de téléchargement des pièces jointes."
    ) {
      input.setAttribute('disabled', true);
    } else {
      input.removeAttribute('disabled');
    }
  });

  const isCommuneDPEC = isCommuneDPECheck(formData.villeArcachonAutre);
  const isCommuneDPECOptional = isCommuneDPECheckOptional(
    formData.villeArcachonAutre
  );
  const isCommuneDPEF = isCommuneDPEFile(formData.villeArcachonAutre);

  return (
    <>
      {loading && (
        <div
          className="modal modal-sm fade show d-block"
          tabIndex="-1"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body d-flex justify-content-center text-black">
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                &nbsp;Chargement en cours ...
              </div>
            </div>
          </div>
        </div>
      )}
      <header className="d-flex flex-column align-items-center justify-content-center pt-4 pb-4 header">
        <h1 className="title text-center">4. Validation de la demande</h1>
        <div className="divider--title m-4"></div>
      </header>
      <section>
        {/* ************************************************************
        composant contenant tous les uploads avec conditions d'affichage
        ************************************************************ */}
        <div className="background--warning p-3">
          <p>
            Afin de traiter votre demande, nous devons collecter certaines
            informations personnelles, y compris des pièces jointes que vous
            devrez télécharger.
          </p>
          <p>
            Nous vous informons que toutes les pièces jointes que vous
            téléchargez seront stockées sur nos serveurs en France tout au long
            du processus de complétion du formulaire.
            <br />
            Dans le cas où vous ne finalisez pas le formulaire, toutes les
            données et pièces jointes que vous avez téléchargées seront
            automatiquement supprimées de nos serveurs après 120 minutes.
            Toutefois, si vous finalisez le formulaire et soumettez votre
            demande, les pièces jointes seront stockées dans nos archives
            conformément à notre politique de conservation des données.
          </p>
          <p>
            En cliquant sur le bouton "J'accepte", vous donnez votre
            consentement explicite pour que nous collections, stockions et
            utilisions vos données personnelles conformément à notre politique
            de confidentialité (
            <a href="#" target="_blank" rel="noreferrer">
              lien vers politique RGPD
            </a>
            ).
            <br />
            Si vous ne donnez pas votre consentement, vous ne pourrez pas
            soumettre votre demande.
          </p>
          <div className="form-check position-relative">
            <input
              className="form-check-input page-4-required radio-group"
              type="checkbox"
              onChange={handleChange}
              onInput={inputFocus}
              value="J'accepte les conditions de téléchargement des pièces jointes."
              name="Check13"
              id="Check13"
              checked={
                formData.Check13 ===
                "J'accepte les conditions de téléchargement des pièces jointes."
              }
            />
            <label className="form-check-label" htmlFor="Check13">
              <strong>
                J'accepte les conditions de téléchargement des pièces
                jointes.&nbsp;<span className="text-danger">*</span>
              </strong>
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
        {/* ************************
          upload photo du bien
         ********************************* */}
        <div className="row mt-4 mb-4 d-block ProPhoto">
          <label htmlFor="input-file-ProPhoto" className="form-label fw-bold">
            Ajout de(s) photo(s) du bien
          </label>
          <div className="col-12 col-md-6">
            <div className="d-flex align-items-center position-relative form-upload">
              <input
                className="form-control files-upload getLabel"
                type="file"
                name="ProPhoto"
                onChange={handleChangeFiles}
                onInput={inputFocus}
                id="input-file-ProPhoto"
                accept="image/png, image/jpeg, image/jpg, .pdf"
              />
              <span
                className="alert alert-secondary m-0 files-upload-supp"
                data-bs-toggle="modal"
                data-bs-target="#ModalProPhoto"
              >
                <i
                  className="btn-icon far fa-trash-alt fa-lg"
                  title="Supprimer les pièces jointes"
                ></i>
              </span>
              <div
                className="modal fade"
                id="ModalProPhoto"
                tabIndex="-1"
                aria-labelledby="ModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header border-0">
                      <h5 className="modal-title">Confirmer la suppression</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Êtes-vous sur de vouloir supprimer les pièces jointes ?
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-warning btn-md"
                        data-bs-dismiss="modal"
                      >
                        Annuler
                      </button>
                      <button
                        type="button"
                        className="btn btn-warning btn-md"
                        name="ProPhoto"
                        id="LM"
                        onClick={handleResetInputFiles}
                        data-bs-dismiss="modal"
                      >
                        Supprimer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="invalid-tooltip file-size d-none"
                id="file-size-alert_ProPhoto"
              >
                Le fichier sélectionné est trop volumineux
              </div>
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            {formData.files &&
              Array.isArray(formData.files.ProPhoto) &&
              formData.files.ProPhoto.length > 0 && (
                <div className="alert alert-success mt-2 d-block" role="alert">
                  {formData.files.ProPhoto.map((item, index) => (
                    <p key={index} className="m-0">
                      &#10004;&nbsp;{item}
                    </p>
                  ))}
                </div>
              )}
          </div>
        </div>
        <div className={isCommuneDPEF ? 'd-block mb-4' : 'd-none'}>
          <label htmlFor="input-file-DPECU" className="form-label fw-bold">
            Diagnostic de Performance Énergétique (DPE) du local objet de la
            demande :&nbsp;
            <span className="text-danger">*</span>
          </label>
          <div className="col-12 col-md-6">
            <div className="d-flex align-items-center position-relative form-upload">
              <input
                className={
                  isCommuneDPEF
                    ? 'form-control files-upload page-4-required getLabel'
                    : 'form-control files-upload getLabel'
                }
                type="file"
                name="DPECU"
                id="input-file-DPECU"
                onChange={handleChangeFiles}
                onInput={inputFocus}
                required
                accept="image/png, image/jpeg, image/jpg, .pdf"
              />
              <span
                className="alert alert-secondary m-0 files-upload-supp"
                data-bs-toggle="modal"
                data-bs-target="#ModalDPECU"
              >
                <i
                  className="btn-icon far fa-trash-alt fa-lg"
                  title="Supprimer les pièces jointes"
                ></i>
              </span>
              <div
                className="modal fade"
                id="ModalDPECU"
                tabIndex="-1"
                aria-labelledby="ModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header border-0">
                      <h5 className="modal-title">Confirmer la suppression</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Êtes-vous sur de vouloir supprimer les pièces jointes ?
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-warning btn-md"
                        data-bs-dismiss="modal"
                      >
                        Annuler
                      </button>
                      <button
                        type="button"
                        className="btn btn-warning btn-md"
                        name="DPECU"
                        id="DPE_CU"
                        onClick={handleResetInputFiles}
                        data-bs-dismiss="modal"
                      >
                        Supprimer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="invalid-tooltip file-size d-none"
                id="file-size-alert_DPECU"
              >
                Le fichier sélectionné est trop volumineux
              </div>
              <div className="invalid-tooltip">
                Veuillez remplir ce champs obligatoire
              </div>
            </div>
            {formData.files &&
              Array.isArray(formData.files.DPECU) &&
              formData.files.DPECU.length > 0 && (
                <div className="alert alert-success mt-2 d-block" role="alert">
                  {formData.files.DPECU.map((item, index) => (
                    <p key={index} className="m-0">
                      &#10004;&nbsp;{item}
                    </p>
                  ))}
                </div>
              )}
          </div>
        </div>
        <div className={isCommuneDPEC ? 'd-block mb-4 mt-4' : 'd-none'}>
          <div className="form-check position-relative">
            <input
              className={
                isCommuneDPEC && !isCommuneDPECOptional
                  ? 'form-check-input page-4-required radio-group'
                  : 'form-check-input radio-group'
              }
              type="checkbox"
              onChange={handleChange}
              onInput={inputFocus}
              value="J'atteste sur l'honneur avoir obtenu un diagnostic de performance énergétique (DPE) valide dont le niveau est compris entre les classes A et E"
              name="CheckDPEArcachon"
              id="CheckDPEArcachon"
              checked={
                formData.CheckDPEArcachon ===
                "J'atteste sur l'honneur avoir obtenu un diagnostic de performance énergétique (DPE) valide dont le niveau est compris entre les classes A et E"
              }
            />
            <label className="form-check-label" htmlFor="CheckDPEArcachon">
              <strong>
                J'atteste sur l'honneur avoir obtenu un diagnostic de
                performance énergétique (DPE) valide dont le niveau est compris
                entre les classes A et E
                {!isCommuneDPECOptional && (
                  <>
                    &nbsp;<span className="text-danger">*</span>
                  </>
                )}
              </strong>
            </label>
            <div className="invalid-tooltip">
              Veuillez valider cette attestation
            </div>
          </div>
        </div>
      </section>
      <section className="background--warning p-4">
        <div className="mb-4">
          <p className="fw-bold">
            Veuillez accepter les CGU&nbsp;:&nbsp;
            <span className="text-danger">*</span>
          </p>
          <div className="form-check position-relative">
            <input
              id="Check1"
              className="form-check-input page-4-required radio-group getLabel"
              type="checkbox"
              name="Check1"
              onChange={handleChange}
              onInput={inputFocus}
              value="Je confirme avoir lu, compris et accepté les CGU et je souhaite déposer une demande de changement d'usage à caractère personnel"
              checked={
                formData.Check1 ===
                "Je confirme avoir lu, compris et accepté les CGU et je souhaite déposer une demande de changement d'usage à caractère personnel"
              }
            />
            <label className="form-check-label" htmlFor="Check1">
              Je confirme avoir lu, compris et accepté les{' '}
              <a href={CGU} target="blank">
                CGU
              </a>{' '}
              et je souhaite déposer une demande de changement d'usage à
              caractère personnel.
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
        <p>
          <strong>
            Veuillez accepter les conditions ci-dessous&nbsp;:&nbsp;
            <span className="text-danger">*</span>
          </strong>
        </p>
        <div
          className={
            formData.ProResidencePrincipale === 'Oui'
              ? 'mb-3 d-block'
              : 'd-none'
          }
        >
          <div className="form-check position-relative">
            <input
              id="Check6"
              className={
                formData.ProResidencePrincipale === 'Oui'
                  ? 'form-check-input page-4-required radio-group getLabel'
                  : 'form-check-input getLabel'
              }
              type="checkbox"
              onChange={handleChange}
              onInput={inputFocus}
              name="Check6"
              value="Dans le cas présent, j'atteste sur l'honneur que les pièces consacrées à l'habitation constituent ma résidence principale."
              checked={
                formData.Check6 ===
                "Dans le cas présent, j'atteste sur l'honneur que les pièces consacrées à l'habitation constituent ma résidence principale."
                  ? true
                  : false
              }
            />
            <label className="form-check-label" htmlFor="Check6">
              Dans le cas présent, j'atteste sur l'honneur que les pièces
              consacrées à l'habitation constituent ma résidence principale.
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div className="form-check position-relative">
            <input
              id="Check2"
              className="form-check-input page-4-required radio-group getLabel"
              type="checkbox"
              onChange={handleChange}
              onInput={inputFocus}
              name="Check2"
              value="Je certifie sur l'honneur l'exactitude des informations fournies dans cette demande de changement d'usage à caractère personnel déposée en ligne"
              checked={
                formData.Check2 ===
                "Je certifie sur l'honneur l'exactitude des informations fournies dans cette demande de changement d'usage à caractère personnel déposée en ligne"
                  ? true
                  : false
              }
            />
            <label className="form-check-label" htmlFor="Check2">
              Je certifie sur l'honneur l'exactitude des informations fournies
              dans cette demande de changement d'usage à caractère personnel
              déposée en ligne.
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div className="form-check position-relative">
            <input
              id="Check4"
              className="form-check-input page-4-required radio-group getLabel"
              type="checkbox"
              onChange={handleChange}
              onInput={inputFocus}
              value="J'accepte de recevoir l'accusé de réception de ma demande de manière dématérialisée et toute demande et décision afférente à ma demande d'autorisation de changement d'usage."
              name="Check4"
              checked={
                formData.Check4 ===
                "J'accepte de recevoir l'accusé de réception de ma demande de manière dématérialisée et toute demande et décision afférente à ma demande d'autorisation de changement d'usage."
              }
            />
            <label className="form-check-label" htmlFor="Check4">
              J'accepte de recevoir l'accusé de réception de ma demande de
              manière dématérialisée et toute demande et décision afférente à ma
              demande d'autorisation de changement d'usage.
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div className="form-check position-relative">
            <input
              id="Check10"
              className="form-check-input page-4-required radio-group getLabel"
              type="checkbox"
              onChange={handleChange}
              onInput={inputFocus}
              value="J'atteste que le bien ne fait pas l'objet d'un conventionnement (logements sociaux, logements conventionnés APL, les logements conventionnés Anah (agence nationale de l'habitat))"
              name="Check10"
              checked={
                formData.Check10 ===
                "J'atteste que le bien ne fait pas l'objet d'un conventionnement (logements sociaux, logements conventionnés APL, les logements conventionnés Anah (agence nationale de l'habitat))"
              }
            />
            <label className="form-check-label" htmlFor="Check10">
              J'atteste que le bien ne fait pas l'objet d'un conventionnement
              (logements sociaux, logements conventionnés APL, les logements
              conventionnés Anah (agence nationale de l'habitat)).
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div className="form-check position-relative">
            <input
              id="Check11"
              className="form-check-input page-4-required radio-group getLabel"
              type="checkbox"
              onChange={handleChange}
              onInput={inputFocus}
              value="J'atteste avoir tout pouvoir pour réaliser les présentes démarches"
              name="Check11"
              checked={
                formData.Check11 ===
                "J'atteste avoir tout pouvoir pour réaliser les présentes démarches"
              }
            />
            <label className="form-check-label" htmlFor="Check11">
              J'atteste avoir tout pouvoir pour réaliser les présentes
              démarches.
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
        <div>
          <div className="form-check position-relative">
            <input
              id="Check12"
              className="form-check-input page-4-required radio-group getLabel"
              type="checkbox"
              onChange={handleChange}
              onInput={inputFocus}
              value="J'atteste que le bien loué est en conformité avec les règles d'urbanisme en vigueur"
              name="Check12"
              checked={
                formData.Check12 ===
                "J'atteste que le bien loué est en conformité avec les règles d'urbanisme en vigueur"
              }
            />
            <label className="form-check-label" htmlFor="Check12">
              J'atteste que le bien loué est en conformité avec les règles
              d'urbanisme en vigueur.
            </label>
            <div className="invalid-tooltip">
              Veuillez valider les conditions
            </div>
          </div>
        </div>
      </section>
      {page === 5 && (
        <div className="d-flex flex-column align-items-start position-relative d-block mt-5">
          <p>
            <strong>Votre signature&nbsp;:&nbsp;</strong>
          </p>
          <ReactSignatureCanvas
            ref={sigRef}
            name="Signature"
            penColor="black"
            canvasProps={{ className: 'signatureCanva' }}
            onEnd={handleSignatureEnd}
          />
          <div
            className={
              (formData.Signature === null || formData.Signature === '') &&
              tooltip === true
                ? 'invalid-tooltip d-block'
                : 'd-none'
            }
          >
            Veuillez signer le document
          </div>
          <button
            type="button"
            className="btn btn-warning btn-md"
            onClick={clearSignature}
          >
            Effacer
          </button>
        </div>
      )}
    </>
  );
};

export default Validation;
